<template>
  <b-container class="concursos consulta-classificacao-semed">
    <h2>CONSULTA DE CLASSIFICAÇÃO – PROCESSO SELETIVO SEMED</h2>
    <div class="concursos-body">
      <div class="concursos-list concursos-list--semed" v-loading="loading">
        <ul>
          <li
            :class="{
              'concursos-list__item': true,
              active: isActive(c.slug),
            }"
            v-for="c in cargos"
            :key="c.slug"
          >
            <a
              :class="{
                'concursos-list__item-link': true,
                active: isActive(c.slug),
              }"
              href="#"
              @click.prevent="setActive(c.slug)"
              >{{ c.titulo }}</a
            >
          </li>
        </ul>
      </div>
      <div class="concursos-component" v-loading="loadingActive" v-if="!loading && cargos.length">
        <ul v-if="arquivosAtivos.data && arquivosAtivos.data.length">
          <li v-for="row in arquivosAtivos.data" :key="row.id">
            <a :href="row.arquivo" target="_blank" rel="noopener">{{ row.titulo }}</a>
          </li>
        </ul>
        <span v-else-if="!loadingActive && !loading"
          >Não foram encontrados resultados para essa busca.</span
        >
        <div class="pg" v-if="arquivosAtivos.data && arquivosAtivos.data.length">
          <b-pagination
            class="pt-5"
            align="center"
            v-model="arquivosAtivos.current_page"
            pills
            :total-rows="arquivosAtivos.total"
            @change="handleChangePage"
            :per-page="arquivosAtivos.per_page"
          ></b-pagination>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
const FALLBACK_CARGOS = [
  { slug: "orientacoes-informacoes", titulo: "ORIENTAÇÕES/INFORMAÇÕES" },
  { slug: "agente-administrativo", titulo: "CARGO AGENTE ADMINISTRATIVO" },
  {
    slug: "assistente-pedagogico-educacao-infantil",
    titulo: "CARGO ASSISTENTE PEDAGÓGICO – EDUCAÇÃO INFANTIL",
  },
  { slug: "auxiliar-de-servicos-gerais", titulo: "CARGO AUXILIAR DE SERVIÇOS GERAIS" },
  { slug: "inspetor-de-alunos", titulo: "CARGO INSPETOR DE ALUNOS" },
  { slug: "merendeira", titulo: "CARGO MERENDEIRA" },
  {
    slug: "monitor-de-transporte-escolar",
    titulo: "CARGO MONITOR DE TRANSPORTE ESCOLAR",
  },
  {
    slug: "motorista-de-transporte-escolar",
    titulo: "CARGO MOTORISTA DE TRANSPORTE ESCOLAR",
  },
  { slug: "motorista-i", titulo: "CARGO MOTORISTA I" },
  {
    slug: "professor-1-ao-5-ensino-fundamental",
    titulo: "CARGO PROFESSOR 1º AO 5º ENSINO FUNDAMENTAL",
  },
  { slug: "professor-arte", titulo: "CARGO PROFESSOR ARTE" },
  {
    slug: "professor-de-aee-sala-de-recursos",
    titulo: "CARGO PROFESSOR DE AEE – SALA DE RECURSOS",
  },
  {
    slug: "professor-de-ciencias-da-natureza",
    titulo: "CARGO PROFESSOR DE CIÊNCIAS DA NATUREZA",
  },
  {
    slug: "professor-de-educacao-fisica",
    titulo: "CARGO PROFESSOR DE EDUCAÇÃO FÍSICA",
  },
  {
    slug: "professor-de-educacao-infantil",
    titulo: "CARGO PROFESSOR DE EDUCAÇÃO INFANTIL",
  },
  { slug: "professor-de-geografia", titulo: "CARGO PROFESSOR DE GEOGRAFIA" },
  { slug: "professor-de-historia", titulo: "CARGO PROFESSOR DE HISTÓRIA" },
  {
    slug: "professor-de-lingua-estrangeira-ingles",
    titulo: "CARGO PROFESSOR DE LÍNGUA ESTRANGEIRA - INGLÊS",
  },
  {
    slug: "professor-de-lingua-portuguesa",
    titulo: "CARGO PROFESSOR DE LÍNGUA PORTUGUESA",
  },
  { slug: "professor-de-matematica", titulo: "CARGO PROFESSOR DE MATEMÁTICA" },
  { slug: "psicologo", titulo: "CARGO PSICÓLOGO" },
  { slug: "vigia", titulo: "CARGO VIGIA" },
];

export default {
  name: "ConsultaClassificacaoSemed",
  data() {
    return {
      loading: false,
      loadingActive: false,
      cargos: [],
      arquivosAtivos: { data: [] },
      activeSlug: "",
    };
  },
  methods: {
    async loadCargos() {
      this.loading = true;
      this.cargos = [];
      const res = await this.$axios.get(`classificacao-semed/cargos`).catch(() => null);
      if (res && res.status === 200 && res.data && res.data.data && res.data.data.length) {
        this.cargos = res.data.data;
      } else {
        this.cargos = FALLBACK_CARGOS;
      }
      if (this.cargos.length) {
        this.setActive(this.cargos[0].slug);
      }
      this.loading = false;
    },
    async fetchArquivos(slug, page = 1) {
      this.loadingActive = true;
      window.scrollTo({ top: 0 });
      const res = await this.$axios
        .get(`classificacao-semed/${slug}?page=${page}`)
        .catch((e) => {
          console.error("classificacao-semed", e);
        });
      if (res && res.status === 200) {
        this.arquivosAtivos = res.data;
      }
      this.loadingActive = false;
    },
    handleChangePage(pg) {
      this.fetchArquivos(this.activeSlug, pg);
    },
    isActive(slug) {
      return this.activeSlug === slug;
    },
    setActive(slug) {
      this.activeSlug = slug;
      this.fetchArquivos(slug);
    },
  },
  created() {
    this.loadCargos();
  },
};
</script>

<style lang="scss">
.consulta-classificacao-semed {
  &.container {
    padding: 30px 20px;
    text-align: left;
  }
  h2 {
    font-size: clamp(1rem, 2.5vw, 1.35rem);
    line-height: 1.35;
  }
}

.concursos-list--semed {
  ul li {
    width: min(100%, 340px);
    background: #3b4b95;
    border-top: 1px solid rgba(255, 255, 255, 0.35);
    & a {
      color: #fff !important;
      display: block;
      &.active {
        color: #1f387f !important;
      }
    }
    &.active {
      background: #8ba4c7;
    }
  }
}
</style>
